export default "__VITE_ASSET__CTyZ_ziX__"